import React from "react";
import PropTypes from "prop-types";
import { List as Loader } from "react-content-loader";
import { getTranscriptContent } from "./Transcript.utils";

import style from "./style.module.scss";

const ERROR_MESSAGE = "PARSE ERROR!";

export function TranscriptContent(props) {
  const [transcriptData, setData] = React.useState(undefined);

  !transcriptData &&
    getTranscriptContent(props.transcript)
      .then((data) => {
        setData(data);
      })
      .catch(() => setData(ERROR_MESSAGE));

  const getTranscriptText = () =>
    transcriptData ? getAllTranscriptText(transcriptData) : <Loader />;

  return <div className={style.transcriptContent}>{getTranscriptText()}</div>;
}

TranscriptContent.propTypes = {
  /**
   * path containing transcript content data
   */
  transcript: PropTypes.string,
};

const getAllTranscriptText = (transcriptData) => {
  if (transcriptData === ERROR_MESSAGE) return transcriptData;
  const keys = Object.keys(transcriptData);
  const textArr = keys.map((id) => {
    return transcriptData[id].text;
  });
  return textArr.map((value) => (
    <span className={style.transcriptContent_text}>{value}</span>
  ));
};
